<template>
    <div class="pt-3 pb-5">
        <div class="row">
            <div class="col-12">
                <div class="d-flex">
                    <h3>Podgląd</h3>
                    <button class="btn btn-sm btn-primary ml-auto" data-toggle="modal" @click="openModal()" data-target="#modalCookie">Dodaj nowe ciasteczko</button>
                </div>
                <hr>

                <div class="table-responsive mt-3">
                <table class="table table-sm table-hover">
                    <thead class="thead-light">
                        <tr>
                        <th scope="col">#</th>
                        <th scope="col">Tutuł</th>
                        <th scope="col">Url</th>
                        <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="data">
                        <tr v-for="(item, key) in data" :key="key">
                            <th scope="row">{{key + 1}}</th>
                            <td>{{item.title}}</td>
                            <td><a target="_blank" :href="item.url">{{item.url}}</a></td>
                            <th>
                                <button type="button" class="btn btn-sm btn-primary my-1 mr-2" data-toggle="modal" data-target="#modalCookie"
                                    @click="openModal('edit', item.id)"
                                >Edytuj</button>

                                <button type="button" data-toggle="modal" data-target="#removeModal" class="btn btn-sm btn-danger my-1"
                                    @click="remove = item"
                                >Usuń</button>
                            </th>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
        <div class="modal fade" ref="remove" id="removeModal" tabindex="-1" aria-labelledby="removeModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="removeModalLabel">Czy na pewno chcesz usunąc kartę <span class="font-weight-bold">{{remove ? remove.title : ''}}</span> ?</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <button type="button" class="btn btn-danger" @click="removeCard(remove.id)">Usuń</button>
                </div>
                </div>
            </div>
        </div>
        <div class="modal fade" ref="details" id="modalCookie" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="CookieLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="CookieLabel">{{ modal.title }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="list-group list-group-horizontal" id="list-tab" role="tablist">
                                <a class="list-group-item list-group-item-action active" id="list-content-list" data-toggle="list" href="#list-content" role="tab" aria-controls="content">Opis</a>
                                <a class="list-group-item list-group-item-action" id="list-image-list" data-toggle="list" href="#list-image" role="tab" aria-controls="image">Zdjęcie</a>
                            </div>
                        </div>
                        <div class="col-12 mt-5 position-relative">
                            <div class="d-flex justify-content-center align-items-center loading" v-if="loadingCookie" ref="loadingCookie">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="tab-content" id="nav-tabContent">
                                <div class="tab-pane fade show active" id="list-content" role="tabpanel" aria-labelledby="list-content-list">
                                    <form
                                        ref="submitForm"
                                        @submit.prevent="submitForm($event)">
                                    <div class="form-group">
                                        <InputLabel
                                            label="Tytuł"
                                            name="title"
                                            v-if="activeCookie"
                                            :value="activeCookie.title"
                                            :invalid="validMessage ? (validMessage.title ? validMessage.title : null) : null"
                                        />
                                        <InputLabel
                                            label="Tytuł"
                                            name="title"
                                            value="Ciastko z wróżbą"
                                            v-else

                                            :invalid="validMessage ? (validMessage.title ? validMessage.title : null) : null"
                                        />
                                        </div>
                                        <div class="form-group">
                                            <InputLabel
                                                label="Opis przy udostępnianiu"
                                                name="desc"
                                                v-if="activeCookie"
                                                :value="activeCookie.share_content"
                                                :invalid="validMessage ? (validMessage.desc ? validMessage.desc : null) : null"
                                            />
                                            <InputLabel
                                                label="Opis przy udostępnianiu"
                                                name="desc"
                                                v-else

                                                :invalid="validMessage ? (validMessage.desc ? validMessage.desc : null) : null"
                                            />
                                        </div>
                                        <div class="form-group">
                                            <hr class="my-4">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" v-model="checked" name="show_content" id="show_content">
                                                <label class="custom-control-label" for="show_content">Wyświetlić opis do ciasteczka ?
                                                    <span
                                                        class="mb-0"
                                                        :class="checked ? 'text-success' : 'text-danger'"
                                                    >{{ checked ? 'Tak' : 'Nie' }}</span>
                                                </label>
                                            </div>
                                                <SunEditor
                                                    v-if="activeCookie"
                                                    :value="activeCookie.content"
                                                    name="content"
                                                    class="pt-3"
                                                    label="Treść opisu ciasteczka"

                                                    :invalid="validMessage ? (validMessage.content ? validMessage.content : null) : null"
                                                />
                                                <SunEditor
                                                    v-else
                                                    name="content"
                                                    class="pt-3"
                                                    label="Treść opisu ciasteczka"

                                                    :invalid="validMessage ? (validMessage.content ? validMessage.content : null) : null"
                                                />
                                        </div>
                                        <div class="form-group">
                                            <input type="hidden" name="image" :value="newCookieUrl">
                                            <button type="submit" class="btn btn-primary">Zapisz</button>
                                        </div>
                                    </form>
                                </div>
                                <div class="tab-pane fade" id="list-image" role="tabpanel" aria-labelledby="list-image-list">
                                    <img v-if="activeCookie" :src="activeCookie.url" class="mw-100 mh-100 m-auto d-block" style="max-width:180px">

                                    <h3 class="text-center font-weight-bold"
                                        :class="activeCookie ? 'mt-5' : ''"
                                    >Wybierz grafikę</h3>
                                    <hr>
                                    <div class="row" v-if="gallery" style="max-height: 500px; overflow: auto">
                                        <div class="col-xl-2 col-lg-4 col-sm-6 text-center" v-for="(item, key) in gallery" :key="key">
                                            <div
                                                class="position-relative shadow gallery-single"
                                                :class="activeImage == key ? 'active' : ''"
                                                ref="imageActive"
                                            >
                                                <img :src="item.url" class="mw-100 mh-100 img-thumbnail o-fit" style="height:180px">

                                                <div class="gallery-action position-absolute">
                                                    <button class="btn btn-success rounded-circle p-2"
                                                        v-if="activeCookie"
                                                        @click.prevent="changeImage(item.id)"
                                                    ><iconSelect /></button>
                                                    <button class="btn btn-success rounded-circle p-2"
                                                        v-else
                                                        @click.prevent="selectImage(item.id, key)"
                                                    ><iconSelect /></button>
                                                </div>
                                            </div>
                                            <p>{{item.name}}</p>
                                        </div>
                                    </div>
                                    <p v-else-if="!gallery || gallery.length == 0">Brak zdjęć</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" v-if="activeCookie">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Zamknij</button>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import InputFile from '../../ui/InputFile';
    import SunEditor from '../../ui/SunEditor';
    import InputLabel from '../../ui/InputLable';
    import InputImage from '../../ui/FileUpload';
    import Select from '../../ui/Select';

    import iconSelect from '../../icon/select';
    import iconTrash from '../../icon/trash';

    export default {
        data() {
            return {
                token: this.$parent._props.api_token,
                data: null,
                activeCookie: null,
                activeImage: null,
                loadingCookie: false,
                validMessage: null,
                cookie: null,
                gallery: null,
                newCookieUrl:null,
                remove: null,
                checked: false,

                modal:
                {
                    title: null,
                }
            }
        },
        components: {
            InputFile, SunEditor, InputImage, Select, iconSelect, InputLabel, iconTrash
        },
        mounted(){
            axios.defaults.params = {};
            axios.defaults.params['api_token'] = this.token;

            this.$parent._data.loading = true;

            this.fetchData();
            this.fetchGallery();
        },
        methods: {
            fetchData(){
                let _this = this;
                this.$parent._data.loading = true;
                axios
                .get('/api/get-data', {
                    params:
                    {
                        'option': 'cookie',
                    }
                }).then(response => {

                    this.data = response.data;

                    $('.loading').animate({
                        opacity: 0,
                    }, 1000, function(){
                        _this.$parent._data.loading = false;
                    })
                });
            },
            fetchGallery(){
                axios
                .get('/api/get-data', {
                    params:
                    {
                        'option': 'gallery',
                    }
                }).then(response => {
                    this.gallery = response.data;
                })
            },

            submitForm(el) {
                let _this = this;
                let form = new FormData();
                let _form = $(el.target).serializeArray();

                $.each(_form, function () {
                    form.append(this.name, this.value);
                });

                if(this.activeCookie != null)
                {
                    axios
                    .post('/cookie/edit/' + this.activeCookie.id, form).then(response => {

                        this.$parent._data.message.success = response.data.success;
                        this.$parent._data.message.content = response.data.content;

                        this.fetchData();
                        this.openModal('edit', this.activeCookie.id);
                    })
                    .catch(error => {
                        if (error.response.status == 422){
                            this.validMessage = error.response.data.errors;
                            this.$parent._data.message.error = true;
                            this.$parent._data.message.content = 'Uzupełnij pola prawidłowymi danymi!';

                            $('.loading').animate({
                                opacity: 0,
                            }, 1000, function(){
                                _this.$parent._data.loading = false;
                            })
                        }
                    });
                }
                else
                {
                    axios
                    .post('/cookie/create', form).then(response => {

                        this.$parent._data.message.success = response.data.success;
                        this.$parent._data.message.content = response.data.content;

                        this.validMessage = null;

                        this.fetchData();

                        this.activeImage = null;
                        $(this.$refs.details).modal('hide');

                    })
                    .catch(error => {
                        if (error.response.status == 422){
                            this.validMessage = error.response.data.errors;
                            this.$parent._data.message.error = true;
                            this.$parent._data.message.content = 'Uzupełnij pola prawidłowymi danymi!';

                            $('.loading').animate({
                                opacity: 0,
                            }, 1000, function(){
                                _this.$parent._data.loading = false;
                            })
                        }
                    });
                }
            },

            openModal(option, id){
                let _this = this;

                if(option == 'edit')
                {
                    this.loadingCookie = true;
                    this.modal.title = 'Edytuj kartę';
                    axios
                    .get('/api/get-data', {
                        params:
                        {
                            'option': 'cookie_details',
                            'id': id,
                        }
                    }).then(response => {

                        this.activeCookie = response.data;
                        this.checked = response.data.show_content ? true : false;

                        $(_this.$refs.loadingCookie).animate({
                            opacity: 0,
                        }, 1000, function(){
                            _this.loadingCookie = false;
                        })
                    });
                }
                else
                {
                    this.modal.title = 'Dodaj nowe ciasteczko';
                    this.activeCookie = null;
                    this.checked = false;
                }
            },
            removeCard(id){

                axios
                .post('/cookie/remove/' + id).then(response => {

                    this.$parent._data.message.success = response.data.success;
                    this.$parent._data.message.content = response.data.content;

                    this.validMessage = null;

                    this.fetchData();

                    $(this.$refs.remove).modal('hide');
                });
            },
            changeImage(id){
                axios
                .post('/cookie/image/' + this.activeCookie.id + '/' + id).then(response => {

                    this.$parent._data.message.success = response.data.success;
                    this.$parent._data.message.content = response.data.content;

                    this.fetchData();
                    this.openModal('edit', this.activeCookie.id);
                });
            },
            selectImage(id, active){
                axios
                .get('/api/image/new/' + id).then(response => {
                    this.newCookieUrl = response.data.url;
                });

                this.activeImage = active;
            }
        },
    }
</script>
